import script from "./CardBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBox.vue?vue&type=script&setup=true&lang=js"

import "./CardBox.vue?vue&type=style&index=0&id=2faf8200&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2faf8200"]])

export default __exports__